import { useState } from 'react'
import { signInWithSlack } from '../lib/supabase'
import { Button } from './ui/button'

export function WorkspaceNameRecovery({ name }: { name: string }) {
  const [signingIn, setSigningIn] = useState(false)
  const [error, setError] = useState('')
  if (name.trim().toLowerCase() !== 'your workspace') return null
  const reconnect = async () => {
    if (signingIn) return
    setSigningIn(true)
    setError('')
    try {
      const url = new URL(window.location.href)
      url.hash = ''
      url.searchParams.set('setup', 'resume')
      await signInWithSlack(url.toString())
    } catch {
      setError('Unable to open Slack sign-in. Please try again.')
      setSigningIn(false)
    }
  }
  return <div className="space-y-1 text-sm">
    <p className="text-muted-foreground">Sign in with Slack again to sync your workspace name.</p>
    <Button variant="outline" disabled={signingIn} onClick={reconnect} className="min-h-11">{signingIn ? 'Opening Slack...' : 'Sync workspace name'}</Button>
    {error && <p role="alert" className="text-destructive">{error}</p>}
  </div>
}
